import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaFacebookF } from "react-icons/fa";
import ChatWidget from "./ChatWidget";
import leadsnow from "../assets/leadsnow-cleaning-logo.png";
import shopping from "../assets/cleaningsup.png";
import dusty from "../assets/dusty.png";
import vac from "../assets/vac.jpg";
import { useMemo, useState } from "react";
import LanguageSwitcher from "./LanguageSwitcher";
import { useAppContext } from "../AppContext";
import plus from "../assets/ComCleanPlus.png";
import image99 from "../assets/$99 value big.png";
import image49 from "../assets/$49 Com Cleaning.png";
import marketing from "../assets/marketing-kit.png";
import telemarekting from "../assets/telemarekting.png";
import posty from "../assets/posty.png";
import brochure from "../assets/brochure.png";
import StripeFinalCodeCheck from "./StripeFinalCodeCheck";
import { ES_HOME_PATH, ES_CLIENTS_PATH, ES_PROMOTE_PATH } from "../routes";

const pageUrl = `https://www.commercialcleaningleadsforyou.com${ES_CLIENTS_PATH}`;

const ConseguirClientesLimpieza = () => {
  const faqItems = [
    {
      key: "1",
      label: "¿Cómo puedo conseguir clientes para mi negocio de limpieza si apenas estoy comenzando?",
      children:
        "El método más rápido es el contacto constante con responsables de decisiones verificados en negocios que ya contratan servicios de limpieza. Esto normalmente implica usar leads de limpieza comercial combinados con llamadas telefónicas, correos electrónicos o correo directo durante varias semanas.",
    },
    {
      key: "2",
      label: "¿Con qué frecuencia debo dar seguimiento a clientes potenciales de limpieza?",
      children:
        "La mayoría de las empresas de limpieza dan seguimiento de 5 a 7 veces en un periodo de 30 a 45 días. Los responsables de decisiones suelen estar ocupados, por lo que un seguimiento repetido y profesional aumenta la probabilidad de respuesta sin resultar invasivo.",
    },
    {
      key: "3",
      label: "¿Los leads de limpieza comercial son exclusivos?",
      children:
        "La exclusividad de los leads depende del proveedor. Los leads más efectivos no se revenden repetidamente y se entregan a un solo negocio de limpieza a la vez, lo que reduce la competencia y mejora las tasas de respuesta.",
    },
    {
      key: "4",
      label: "¿Los leads de limpieza comercial realmente funcionan?",
      children:
        "Sí. Los leads de limpieza comercial funcionan cuando son precisos, están bien dirigidos y se combinan con un seguimiento constante. Los negocios que contactan a sus leads varias veces y dan seguimiento a sus resultados suelen obtener los mejores resultados.",
    },
    {
      key: "5",
      label: "¿Cuál es la forma más rápida de conseguir clientes de limpieza comercial?",
      children:
        "El método más rápido es el contacto constante con responsables de decisiones verificados en negocios que ya utilizan leads de limpieza comercial, combinado con llamadas telefónicas, correos electrónicos y correo directo durante varias semanas.",
    },
    {
      key: "6",
      label: "¿Qué tipo de negocios contratan con más frecuencia servicios de limpieza comercial?",
      children:
        "Las industrias más comunes incluyen edificios de oficinas, consultorios médicos y dentales, escuelas, tiendas minoristas, almacenes y empresas de administración de propiedades. Estos negocios suelen tener necesidades de limpieza recurrentes.",
    },
    {
      key: "7",
      label: "¿Las llamadas en frío siguen siendo efectivas para negocios de limpieza?",
      children:
        "Sí. Cuando se hacen de forma profesional y con leads bien dirigidos, las llamadas en frío siguen siendo una de las formas más efectivas de presentar servicios de limpieza y agendar recorridos o cotizaciones.",
    },
    {
      key: "8",
      label: "¿Puedo usar los leads de limpieza para marketing por correo electrónico en lugar de llamar?",
      children:
        "Sí. Los leads de limpieza se pueden usar para contacto por correo electrónico, especialmente cuando se combinan con una breve introducción, una descripción del servicio y una secuencia de seguimiento. El contacto por varios canales suele generar mejores resultados que usar un solo método.",
    },
    {
      key: "9",
      label: "¿Cuántos leads de limpieza necesito para conseguir nuevos clientes?",
      children:
        "La cantidad varía según el mercado y el tipo de servicio. Muchas empresas de limpieza comienzan con 100 a 300 leads dirigidos y ajustan su mensaje y enfoque según las respuestas y tasas de conversión.",
    },
    {
      key: "10",
      label: "¿Qué debo decir al contactar a un cliente potencial de limpieza?",
      children:
        "Enfócate en presentar tu empresa, confirmar quién administra los servicios de limpieza y preguntar si están abiertos a revisar opciones. El objetivo es iniciar una conversación, no cerrar un trato en el primer contacto.",
    },
    {
      key: "11",
      label: "¿Cuánto tiempo toma conseguir un contrato de limpieza comercial?",
      children:
        "Algunos contratos se consiguen en semanas, mientras que otros toman meses. La constancia, el seguimiento y una presentación profesional juegan un papel importante en el tiempo que toma.",
    },
    {
      key: "12",
      label: "¿Los leads de limpieza comercial son mejores que los anuncios en línea?",
      children:
        "Los leads y los anuncios tienen propósitos distintos. Los leads te dan acceso directo a los responsables de decisiones, mientras que los anuncios dependen de que los prospectos te encuentren. Muchos negocios de limpieza exitosos usan leads para generar un crecimiento predecible sin depender únicamente de la publicidad.",
    },
    {
      key: "13",
      label: "¿Este enfoque puede escalar conforme crece mi negocio de limpieza?",
      children:
        "No. Muchas empresas de limpieza comienzan con una hoja de cálculo sencilla o un CRM básico para llevar el seguimiento del contacto, las respuestas y los seguimientos.",
    },
    {
      key: "14",
      label: "¿Necesito un software especial para administrar mis leads de limpieza?",
      children:
        "No se necesita un software especial para comenzar. Muchos negocios usan Excel, Google Sheets o un CRM básico para mantenerse organizados. La constancia y el seguimiento importan más que las herramientas.",
    },
  ];

  function IconPill() {
    return (
      <span
        className="inline-flex items-center justify-center shrink-0"
        style={{
          width: 26,
          height: 26,
          borderRadius: 999,
          color: "#1465B7",
          fontWeight: 800,
          lineHeight: 1,
          fontSize: 28,
        }}
        aria-hidden="true"
      >
        +
      </span>
    );
  }

  function MinusBullet() {
    return (
      <span
        className="inline-flex items-center justify-center shrink-0"
        style={{
          width: 22,
          height: 22,
          borderRadius: 999,
          color: "#fff",
          fontWeight: 900,
          lineHeight: 1,
          fontSize: 24,
        }}
        aria-hidden="true"
      >
        −
      </span>
    );
  }

  function FaqCard({ item, open, onToggle }) {
    const CARD_BG = "#E4F7F9";
    const BORDER = "rgba(38,169,74,0.40)";
    const GREEN = "#2FA84F";

    return (
      <div className="w-full">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          className="w-full text-left rounded-full border shadow-sm transition"
          style={{
            background: CARD_BG,
            borderColor: BORDER,
            padding: "12px 14px",
          }}
        >
          <div className="flex items-center gap-3">
            <IconPill />
            <span className="text-[#1465B7] text-lg font-medium leading-snug">
              {item.label}
            </span>
          </div>
        </button>

        <div
          className="overflow-hidden transition-[max-height,opacity,margin] duration-300 ease-in-out"
          style={{
            maxHeight: open ? 220 : 0,
            opacity: open ? 1 : 0,
            marginTop: open ? 10 : 0,
          }}
        >
          <div
            className="rounded-2xl shadow-sm"
            style={{
              background: GREEN,
              padding: "14px 16px",
            }}
          >
            <div className="flex gap-3 items-start">
              <MinusBullet />
              <p className="text-white text-lg leading-relaxed">{item.children}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const [openKeys, setOpenKeys] = useState(new Set());

  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(faqItems.length / 2);
    return {
      leftItems: faqItems.slice(0, mid),
      rightItems: faqItems.slice(mid),
    };
  }, []);

  const { buyNow, loadingHeader, setBuyNow, selectedPrice, setSelectedPrice, leadsCount, setLeadsCount } = useAppContext();

  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];

  return (
    <div>
      <Helmet>
        <title>Cómo Conseguir Clientes para tu Negocio de Limpieza Comercial</title>
        <meta
          name="description"
          content="Aprende cómo las empresas de limpieza comercial consiguen clientes de forma constante con un proceso probado paso a paso y leads de limpieza comercial dirigidos."
        />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" hrefLang="en" href="https://www.commercialcleaningleadsforyou.com/how%20to%20get%20clients%20for%20your%20commercial%20cleaning%20business" />
        <link rel="alternate" hrefLang="es" href={pageUrl} />
        <link rel="alternate" hrefLang="x-default" href="https://www.commercialcleaningleadsforyou.com/" />
        <meta name="language" content="Spanish" />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.commercialcleaningleadsforyou.com/#organization",
      "name": "Leads Now Commercial Cleaning",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "description": "Leads Now Commercial Cleaning ofrece leads de limpieza comercial y datos de contacto listos para usar, ayudando a los negocios de limpieza a conseguir nuevos clientes de forma constante.",
      "email": "leadsnowproducts@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "12020 Shamrock Plaza #200",
        "addressLocality": "Omaha",
        "addressRegion": "NE",
        "postalCode": "68154",
        "addressCountry": "US"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "leadsnowproducts@gmail.com",
        "availableLanguage": ["Spanish", "English"]
      }
    },

    {
      "@type": "WebSite",
      "@id": "https://www.commercialcleaningleadsforyou.com/#website",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "name": "Leads Now Commercial Cleaning",
      "publisher": { "@id": "https://www.commercialcleaningleadsforyou.com/#organization" },
      "inLanguage": "es-419"
    },

    {
      "@type": "WebPage",
      "@id": "${pageUrl}/#webpage",
      "url": "${pageUrl}",
      "name": "Cómo Conseguir Clientes para tu Negocio de Limpieza Comercial",
      "description": "Un proceso comprobado, paso a paso, que usan las empresas de limpieza comercial para ganar nuevos clientes de forma constante, incluyendo cómo llegar a responsables de decisiones, usar leads de limpieza comercial y mantener contacto constante por varios canales.",
      "inLanguage": "es-419",
      "isPartOf": { "@id": "https://www.commercialcleaningleadsforyou.com/#website" },
      "publisher": { "@id": "https://www.commercialcleaningleadsforyou.com/#organization" },
      "mainEntity": [
        { "@id": "${pageUrl}/#howto" },
        { "@id": "${pageUrl}/#faq" },
        { "@id": "${pageUrl}/#summary" },
        { "@id": "${pageUrl}/#service" }
      ],
      "about": [
        { "@type": "Thing", "name": "Limpieza comercial" },
        { "@type": "Thing", "name": "Leads de limpieza comercial" },
        { "@type": "Thing", "name": "Adquisición de clientes" },
        { "@type": "Thing", "name": "Generación de leads" }
      ]
    },

    {
      "@type": "HowTo",
      "@id": "${pageUrl}/#howto",
      "name": "Cómo Conseguir Clientes para tu Negocio de Limpieza Comercial",
      "description": "Un enfoque repetible, paso a paso, que usan las empresas de limpieza comercial exitosas para ganar nuevos clientes de forma constante.",
      "inLanguage": "es-419",
      "totalTime": "P30D",
      "supply": [
        { "@type": "HowToSupply", "name": "Leads de limpieza comercial (contactos empresariales verificados)" }
      ],
      "tool": [
        { "@type": "HowToTool", "name": "Teléfono" },
        { "@type": "HowToTool", "name": "Correo electrónico" },
        { "@type": "HowToTool", "name": "Correo directo" },
        { "@type": "HowToTool", "name": "Seguimiento de contacto (CRM u hoja de cálculo)" }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "Define el tipo de clientes de limpieza que quieres",
          "text": "Ten claridad sobre a quién quieres llegar. Las empresas de limpieza exitosas se enfocan en tipos específicos de clientes, como edificios de oficinas, consultorios médicos o dentales, escuelas y guarderías, almacenes e instalaciones industriales, tiendas minoristas y centros comerciales, y administradores de propiedades e instalaciones multiinquilino."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "Identifica a los responsables de decisiones que controlan los contratos de limpieza",
          "text": "Los contratos de limpieza normalmente los deciden dueños de negocios, gerentes de oficina, gerentes de instalaciones y administradores de propiedades. Muchas empresas de limpieza fallan porque promocionan sus servicios a los contactos equivocados. Para conseguir clientes, debes llegar a las personas que pueden decir que sí."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "Usa leads de limpieza comercial para llegar a los negocios correctos",
          "text": "Los leads de limpieza comercial son contactos empresariales verificados que coinciden con tu mercado objetivo y te permiten llegar directamente a los responsables de decisiones, sin esperar referidos o consultas en línea. Esto elimina la incertidumbre de la prospección."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "Segmenta por ubicación, industria y tipo de edificio",
          "text": "No todos los leads son iguales. Las empresas de limpieza más exitosas se enfocan en un contacto dirigido, no en mensajes masivos. Una segmentación efectiva incluye ciudad, condado o código postal, tipo de negocio o instalación, tamaño del edificio o metros cuadrados, y propiedades ocupadas por el dueño frente a propiedades administradas."
        },
        {
          "@type": "HowToStep",
          "position": 5,
          "name": "Elige un método de contacto y sé constante",
          "text": "Una vez que tienes los leads correctos, la constancia importa más que la perfección. Las empresas de limpieza suelen contactar a sus prospectos mediante llamadas telefónicas, correos de presentación, correo directo y seguimiento con varios contactos. El objetivo no son las ventas instantáneas, es iniciar conversaciones."
        },
        {
          "@type": "HowToStep",
          "position": 6,
          "name": "Mide tus resultados y mejora tu estrategia",
          "text": "Los negocios de limpieza exitosos miden lo que funciona. Da seguimiento a quién responde, qué industrias convierten mejor y qué mensajes generan devoluciones de llamada. Con el tiempo, tu proceso se vuelve más eficiente y predecible."
        }
      ]
    },

    {
      "@type": "ItemList",
      "@id": "${pageUrl}/#summary",
      "name": "Resumen: Cómo Conseguir Clientes para tu Negocio de Limpieza",
      "itemListOrder": "https://schema.org/ItemListOrderAscending",
      "numberOfItems": 5,
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Define a tu cliente ideal" },
        { "@type": "ListItem", "position": 2, "name": "Llega a los responsables de decisiones correctos" },
        { "@type": "ListItem", "position": 3, "name": "Usa leads de limpieza comercial dirigidos" },
        { "@type": "ListItem", "position": 4, "name": "Mantén la constancia en tu contacto" },
        { "@type": "ListItem", "position": 5, "name": "Mide y mejora tu proceso" }
      ]
    },

    {
      "@type": "FAQPage",
      "@id": "${pageUrl}/#faq",
      "url": "${pageUrl}",
      "name": "Preguntas Frecuentes",
      "inLanguage": "es-419",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cómo puedo conseguir clientes para mi negocio de limpieza si apenas estoy comenzando?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El método más rápido es el contacto constante con responsables de decisiones verificados en negocios que ya contratan servicios de limpieza. Esto normalmente implica usar leads de limpieza comercial combinados con llamadas telefónicas, correos electrónicos o correo directo durante varias semanas."
          }
        },
        {
          "@type": "Question",
          "name": "¿Con qué frecuencia debo dar seguimiento a clientes potenciales de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "La mayoría de las empresas de limpieza dan seguimiento de 5 a 7 veces en un periodo de 30 a 45 días. Un seguimiento repetido y profesional aumenta la probabilidad de respuesta sin resultar invasivo."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuál es la forma más rápida de conseguir clientes de limpieza comercial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El método más rápido es el contacto constante con responsables de decisiones verificados en negocios que ya contratan servicios de limpieza, combinado con llamadas telefónicas, correos electrónicos y correo directo."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué tipo de negocios contratan con más frecuencia servicios de limpieza comercial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Edificios de oficinas, consultorios médicos y dentales, escuelas, tiendas minoristas, almacenes y empresas de administración de propiedades suelen tener necesidades de limpieza recurrentes."
          }
        },
        {
          "@type": "Question",
          "name": "¿Las llamadas en frío siguen siendo efectivas para negocios de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí. Cuando se hacen de forma profesional y con leads bien dirigidos, las llamadas en frío siguen siendo una de las formas más efectivas de presentar servicios de limpieza y agendar recorridos o cotizaciones."
          }
        },
        {
          "@type": "Question",
          "name": "¿Puedo usar los leads de limpieza para marketing por correo electrónico en lugar de llamar?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí. Los leads de limpieza se pueden usar para contacto por correo electrónico, especialmente cuando se combinan con una breve introducción, una descripción del servicio y una secuencia de seguimiento."
          }
        },
        {
          "@type": "Question",
          "name": "¿Qué debo decir al contactar a un cliente potencial de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Enfócate en presentar tu empresa, confirmar quién administra los servicios de limpieza y preguntar si están abiertos a revisar opciones. El objetivo es iniciar una conversación, no cerrar un trato en el primer contacto."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánto tiempo toma conseguir un contrato de limpieza comercial?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Algunos contratos se consiguen en semanas, mientras que otros toman meses. La constancia, el seguimiento y una presentación profesional juegan un papel importante en el tiempo que toma."
          }
        },
        {
          "@type": "Question",
          "name": "¿Los leads de limpieza comercial realmente funcionan?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí. Los leads de limpieza comercial funcionan cuando son precisos, están bien dirigidos y se combinan con un seguimiento constante."
          }
        },
        {
          "@type": "Question",
          "name": "¿Los leads de limpieza comercial son mejores que los anuncios en línea?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Los leads te dan acceso directo a los responsables de decisiones, mientras que los anuncios dependen de que los prospectos te encuentren. Muchos negocios de limpieza exitosos usan leads para generar un crecimiento predecible."
          }
        }
      ]
    },

    {
      "@type": "Service",
      "@id": "${pageUrl}/#service",
      "name": "Leads de Limpieza Comercial (500 Leads de Descarga Instantánea)",
      "description": "Leads de contacto empresarial verificados que coinciden con tu mercado objetivo y te ayudan a llegar a los responsables de decisiones de limpieza comercial. Elige tu código postal, descarga y segmenta 500 leads, lanza tu contacto y mide tus resultados.",
      "areaServed": { "@type": "Country", "name": "United States" },
      "provider": { "@id": "https://www.commercialcleaningleadsforyou.com/#organization" },
      "offers": {
        "@type": "Offer",
        "@id": "${pageUrl}/#offer",
        "url": "${pageUrl}",
        "priceCurrency": "USD",
        "price": "199.00",
        "availability": "https://schema.org/InStock",
        "category": "Lead Generation",
        "name": "Comienza por solo $199",
        "description": "Solo $199 por 500 leads de limpieza comercial. Descarga al instante."
      }
    }
  ]
}`}
        </script>
      </Helmet>
      <header className="relative bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
        <div className="px-4 pt-4 md:px-0 md:pt-0 md:absolute md:top-6 md:right-6 z-30">
          <div className="flex items-center gap-4">
            <LanguageSwitcher />

            <a
              href="https://www.facebook.com/profile.php?id=61582707424269"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-block"
              aria-label="Facebook"
            >
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#1877F2] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95">
                <FaFacebookF className="text-white" size={24} />
              </div>
            </a>
          </div>
        </div>

        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
          <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
          <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
          <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce"></div>
          <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 pb-8 pt-2 md:pt-8">
          <div className={`max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 ${(buyNow === 'payment' || buyNow === 'download') ? 'items-start' : 'items-center'}`}>
            <div className="text-center lg:text-left min-w-0">
              <div className="mb-8 flex justify-center lg:justify-start">
                <img
                  src={leadsnow}
                  alt="Leads Now"
                  className="w-[280px] lg:w-[220px]"
                />
              </div>

              <h1 className="text-4xl font-semibold text-[#1465B7] leading-tight">
                Cómo Conseguir Clientes para tu Negocio de Limpieza Comercial
              </h1>

              <>
                <div className="mt-5">
                  <h2 className="text-xl md:text-2xl font-medium mb-8 max-w-xl text-[#1465B7]">
                    Si te preguntas "¿Cómo puedo conseguir clientes para mi negocio de limpieza?", la respuesta no es una sola táctica, es un proceso repetible.
                  </h2>
                </div>

                <h3 className="mt-5 text-xl font-medium text-[#26A94A] mb-10 max-w-xl mx-auto lg:mx-0">
                  A continuación encontrarás un enfoque comprobado, paso a paso, que usan las empresas de limpieza comercial exitosas para ganar nuevos clientes de forma constante.
                </h3>
              </>
            </div>

            <div className="flex justify-end min-w-0">
               <div className={`flex-shrink-0 md:min-w-md w-full ${(buyNow === 'payment' || buyNow === 'download') ? 'lg:max-w-[28rem] lg:w-full' : 'lg:min-w-md lg:w-80'} items-center ${(buyNow === 'payment' || buyNow === 'download') ? '' : 'mt-40'}`}>
                {buyNow === 'home' && (
                  <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                    <div className="flex">
                      <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold  rounded-b-2xl">
                        <span className="text-white text-lg">Leads de Limpieza Comercial Para Ti</span>
                      </button>
                    </div>

                    <div className="px-5 py-4">
                      <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">
                        Consigue tu lista ahora
                      </p>
                      <p className="text-md text-gray-600 mb-4">
                        Envíame {leadsCount} negocios de limpieza comercial cerca de mi
                        <br /> código postal{" "}
                      </p>

                      <div className="flex justify-center mb-6">
                        <div
                          className="
                            w-full
                            bg-[#BFEAF2]
                            border-[3px] border-[#26A94A]
                            rounded-xl
                            overflow-hidden
                            grid grid-cols-3
                          "
                        >
                          {plans.map((p, idx) => (
                            <button
                              key={p.qty}
                              type="button"
                              onClick={() => {
                                setLeadsCount(p.qty);
                                setSelectedPrice(p.price * 100);
                              }}
                              className={`
                                py-2
                                flex flex-col items-center justify-center
                                transition
                                cursor-pointer
                                ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                                ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                              `}
                            >
                              <span
                                className="
                                  text-lg
                                  font-extrabold leading-none
                                  text-[#EAFB55]
                                  drop-shadow-[1.5px_1.5px_0px_#2E7D32]
                                "
                              >
                                {p.qty}
                              </span>
                              <span className="text-sm font-extrabold leading-none text-[#1465B7]">
                                Leads
                              </span>
                              <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">
                                ${p.price}
                              </span>
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="mt-8">
                          <button
                            className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer"
                            style={{ color: "#1465B7", fontSize: "28px" }}
                            onClick={() => setBuyNow('payment')}
                          >
                            Comprar ahora
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(buyNow === 'payment' || buyNow === 'download') && <StripeFinalCodeCheck />}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Strategies Grid */}
      <section className="w-full py-10">
        <div className="mx-auto max-w-5xl px-4">
          <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-3">
            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 1: Define el Tipo de Clientes de Limpieza que Quieres
              </h2>
              <p className="mt-2 text-lg leading-7 text-[#26A94A]">
                Antes de promocionar tu negocio de limpieza, necesitas tener claridad sobre a quién quieres llegar.
              </p>

              <p className="mt-3 text-base text-[#1465B7]">
                Las empresas de limpieza exitosas se enfocan en tipos específicos de clientes, como:
              </p>

              <ul className="mt-2 list-disc space-y-1 pl-5 text-base leading-5 text-[#1465B7]">
                <li>Edificios de oficinas</li>
                <li>Consultorios médicos o dentales</li>
                <li>Escuelas y guarderías</li>
                <li>Almacenes e instalaciones industriales</li>
                <li>Tiendas minoristas y centros comerciales</li>
                <li>Administradores de propiedades e instalaciones multiinquilino</li>
              </ul>

              <p className="mt-3 text-base leading-5 text-[#1465B7]">
                Mientras más claro sea tu objetivo, más fácil será llegar a los responsables de decisiones.
              </p>
            </div>

            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 2: Identifica a los Responsables de Decisiones que Controlan los Contratos de Limpieza
              </h2>

              <p className="mt-2 text-base leading-5 text-[#1465B7]">
                Los contratos de limpieza normalmente los deciden:
              </p>

              <ul className="mt-2 list-disc space-y-1 pl-5 text-base leading-5 text-[#1465B7]">
                <li>Dueños de negocios</li>
                <li>Gerentes de oficina</li>
                <li>Gerentes de instalaciones</li>
                <li>Administradores de propiedades</li>
              </ul>

              <p className="mt-3 text-base leading-5 text-[#1465B7]">
                Muchas empresas de limpieza fallan porque promocionan sus servicios a los contactos equivocados.
              </p>

              <p className="mt-3 text-base text-[#1465B7]">
                Para conseguir clientes, debes llegar a las personas que pueden decir que sí.
              </p>
            </div>

            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 3: Usa Leads de Limpieza Comercial para Llegar a los Negocios Correctos
              </h2>

              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Una de las formas más efectivas de conseguir clientes de limpieza es usando leads de limpieza comercial.
              </h3>

              <p className="mt-3 text-base leading-6 text-[#1465B7]">
                Los leads de limpieza comercial son contactos empresariales verificados que coinciden con tu mercado objetivo y te permiten llegar directamente a los responsables de decisiones, sin esperar referidos o consultas en línea.<br />
                Esto elimina la incertidumbre de la prospección.
              </p>
            </div>

            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 4: Segmenta por Ubicación, Industria y Tipo de Edificio
              </h2>

              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                No todos los leads son iguales. Las empresas de limpieza más exitosas se enfocan en un contacto dirigido, no en mensajes masivos.
              </h3>

              <p className="mt-3 text-base text-[#1465B7]">
                Una segmentación de leads efectiva incluye:
              </p>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-base leading-5 text-[#1465B7]">
                <li>Ciudad, condado o código postal</li>
                <li>Tipo de negocio o instalación</li>
                <li>Tamaño del edificio o metros cuadrados</li>
                <li>Propiedades ocupadas por el dueño frente a propiedades administradas</li>
              </ul>

              <p className="mt-3 text-base leading-5 text-[#1465B7]">
                Una buena segmentación mejora las tasas de respuesta y reduce el esfuerzo desperdiciado.
              </p>
            </div>

            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 5: Elige un Método de Contacto y Sé Constante
              </h2>

              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Una vez que tienes los leads correctos, la constancia importa más que la perfección.
              </h3>

              <p className="mt-3 text-base text-[#1465B7]">
                Las empresas de limpieza suelen contactar a sus prospectos mediante:
              </p>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-base leading-5 text-[#1465B7]">
                <li>Llamadas telefónicas</li>
                <li>Correos de presentación</li>
                <li>Correo directo</li>
                <li>Seguimiento con varios contactos</li>
              </ul>

              <p className="mt-3 text-base leading-5 text-[#1465B7]">
                El objetivo no son las ventas instantáneas -- es iniciar conversaciones.
              </p>
            </div>

            <div className="rounded-lg border-2 border-[#26A94A] bg-[#E0F7FA]  p-4">
              <h2 className="mt-2 text-xl font-medium text-[#26A94A]">
                Paso 6: Mide tus Resultados y Mejora tu Estrategia
              </h2>

              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">
                Los negocios de limpieza exitosos miden lo que funciona.
              </h3>

              <p className="mt-3 text-base text-[#1465B7]">
                Mide:
              </p>
              <ul className="mt-2 list-disc space-y-1 pl-5 text-base leading-5 text-[#1465B7]">
                <li>Quién responde</li>
                <li>Qué industrias convierten mejor</li>
                <li>Qué mensajes generan devoluciones de llamada</li>
              </ul>

              <p className="mt-3 text-base leading-5 text-[#1465B7]">
                Con el tiempo, tu proceso se vuelve más eficiente y predecible.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full pb-10">
        <div className="mx-auto max-w-5xl px-4">
          <div className="rounded-xl border-2 border-[#26A94A] bg-[#E0F7FA] px-6 py-6 sm:py-8">
            <div className="flex items-center justify-between gap-6">
              <div className="hidden shrink-0 sm:block ml-16">
                <img
                  src={vac}
                  alt="Ilustración de limpieza"
                  className="h-[120px] w-auto md:h-[140px]"
                  draggable={false}
                />
              </div>

              <div className="flex-1 text-center">
                <h2 className="text-[18px] font-extrabold text-[#26A94A] sm:text-[20px]">
                  Por Qué Este Proceso Funciona para Negocios de Limpieza
                </h2>

                <p className="mx-auto mt-2 max-w-2xl text-base text-[#26A94A]">
                  Este método paso a paso funciona porque:
                </p>

                <ul className="mx-auto mt-4 inline-block list-disc space-y-1 pl-5 text-left text-base text-[#1465B7]">
                  <li>Se enfoca en los responsables de decisiones, no en contactos al azar</li>
                  <li>Genera un flujo constante de clientes potenciales</li>
                  <li>Reduce la dependencia de referidos o anuncios</li>
                  <li>Escala conforme tu negocio crece</li>
                </ul>

                <p className="mx-auto mt-4 text-base text-[#26A94A] sm:text-[14px]">
                  Es repetible, medible y controlable.
                </p>
              </div>

              <div className="hidden shrink-0 sm:block mr-16">
                <img
                  src={dusty}
                  alt="Ilustración de limpieza"
                  className="h-[120px] w-auto md:h-[140px]"
                  draggable={false}
                />
              </div>
            </div>

            <div className="mt-6 flex items-center justify-center gap-6 sm:hidden">
              <img
                src={vac}
                alt="Ilustración de limpieza"
                className="h-[92px] w-auto"
                draggable={false}
              />
              <img
                src={dusty}
                alt="Ilustración de limpieza"
                className="h-[92px] w-auto"
                draggable={false}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#BFEAF2] py-10">
        <div className="relative mx-auto max-w-5xl px-4">
          <div className="absolute inset-0">
            <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
            <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
            <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
            <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce"></div>
            <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce"></div>
          </div>
          <div className="px-6 py-8">
            <h2 className="text-center text-xl font-extrabold text-[#1465B7] sm:text-xl">
              Por Qué Este Proceso Funciona para Negocios de Limpieza
            </h2>

            <h4 className="mx-auto mt-4 max-w-3xl text-center text-lg leading-7 text-[#26A94A]">
              Si quieres aplicar este proceso rápidamente, los leads de limpieza comercial te dan ventaja al darte acceso a negocios que ya cumplen con tus criterios.
            </h4>

            <p className="mt-5 text-center text-base font-semibold text-[#1465B7]">
              Tú eliges:
            </p>

            <ul className="mx-auto mt-3 max-w-sm list-disc space-y-2 pl-24 text-base leading-6 text-[#1465B7]">
              <li>Dónde quieres trabajar</li>
              <li>A quién quieres atender</li>
              <li>Qué tan rápido quieres crecer</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="max-w-5xl mx-auto">
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-6">
              <h2 className="text-2xl text-[#1465B7] font-semibold">Preguntas Frecuentes</h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6 px-4">
            <div className="space-y-4">
              {leftItems.map((item) => (
                <FaqCard
                  key={item.key}
                  item={item}
                  open={openKeys.has(item.key)}
                  onToggle={() => {
                    setOpenKeys((prev) => {
                      const next = new Set(prev);
                      if (next.has(item.key)) {
                        next.delete(item.key);
                      } else {
                        next.add(item.key);
                      }
                      return next;
                    });
                  }}
                />
              ))}
            </div>

            <div className="space-y-4">
              {rightItems.map((item) => (
                <FaqCard
                  key={item.key}
                  item={item}
                  open={openKeys.has(item.key)}
                  onToggle={() => {
                    setOpenKeys((prev) => {
                      const next = new Set(prev);
                      if (next.has(item.key)) {
                        next.delete(item.key);
                      } else {
                        next.add(item.key);
                      }
                      return next;
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </section>
      </div>

      <section className="relative w-full bg-[#bfeaf0] py-14">
        <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
        <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
        <div className="absolute top-1/2 right-10 w-8 h-8 bg-white/25 rounded-full animate-bounce"></div>
        <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-white/15 rounded-full animate-bounce"></div>

        <div className="mx-auto w-full max-w-5xl px-4">
          <div className="rounded-2xl px-6 py-8shadow-[0_2px_0_rgba(0,0,0,0.06)] md:px-10">
            <div className="flex flex-col items-center gap-7 md:flex-row md:items-center md:gap-10">
              <div className="shrink-0">
                <div className="flex items-center justify-center">
                  <img
                    src={shopping}
                    alt="Ilustración de artículos de limpieza"
                    className="h-[230px] w-[230px] select-none"
                    draggable={false}
                  />
                </div>
              </div>

              <div className="w-full text-center md:text-left mx-auto md:ml-28 md:mx-0">
                <h2 className="text-xl font-bold leading-tight text-[#1465B7]">
                  Resumen: Cómo Conseguir Clientes para tu Negocio de Limpieza
                </h2>

                <p className="mt-2 text-base text-[#26A94A]">
                  Para conseguir clientes para tu negocio de limpieza:
                </p>

                <div className="mt-2 space-y-1 text-base text-[#2ea44f]">
                  <div className="mx-auto mt-1 space-y-1 pl-5 text-left md:mx-0 text-[#1465B7]">
                    1. Define a tu cliente ideal
                    <br />
                    2. Llega a los responsables de decisiones correctos
                    <br />
                    3. Usa leads de limpieza comercial dirigidos
                  </div>
                  <div className="mx-auto space-y-1 pl-5 text-left md:mx-0 text-[#1465B7]">
                    4. Mantén la constancia en tu contacto
                    <br />
                    5. Mide y mejora tus resultados
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#DBE4E5]">
        <div className="relative z-10 container mx-auto px-4 py-8">
          <div className="block lg:flex max-w-5xl mx-auto">
            <div className="flex-1  max-w-xl text-center lg:text-left">
              <div className="mb-3 max-w-lg">
                <p className="text-[#26A94A] font-bold text-3xl ">
                  {" "}
                  Comienza:{" "}
                  <span className="text-[#1465B7]">
                    Elige tu código postal, <br /> nosotros hacemos el resto.
                  </span>
                </p>
                <div>
                  <ul className="list-disc ml-5 text-lg text-gray-700">
                    <li>
                      Descarga y segmenta los 500 leads de limpieza <br />
                      comercial según tus objetivos de marketing.
                    </li>

                    <li className="my-2">
                      Lanza tu contacto por correo, anuncios, llamadas <br />{" "}
                      o correo directo.
                    </li>

                    <li>
                      Mide tus resultados y ajusta para obtener <br />{" "}
                      mejores resultados.
                    </li>
                  </ul>
                </div>
                <div className="mt-3">
                  <p className="text-gray-700 text-lg leading-normal gap-y-2">
                    No necesitas una agencia. No necesitas un equipo <br />{" "}
                    grande de marketing. Solo la lista correcta y un plan{" "}
                    <br /> inteligente. Así de simple: tú consigues la lista.
                    <br />
                    Tú haces el contacto. Y te quedas con el 100% de las ganancias.
                  </p>
                </div>

                <div className="font-semibold text-[#26A94A] text-lg">
                  <p>
                    Solo ${selectedPrice / 100} por {leadsCount} leads.
                    <br />
                    Leads de Limpieza Comercial Para Ti
                  </p>
                </div>
              </div>
            </div>

            {buyNow === 'home' &&
              <div className="flex-shrink-0 md:min-w-md lg:min-w-md w-full lg:w-80">
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                  <div className="flex">
                    <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold  rounded-b-2xl">
                      <span className="text-white text-lg">Leads de Limpieza Comercial Para Ti</span>
                    </button>
                  </div>

                  <div className="px-5 py-4">
                    <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">
                      Consigue tu lista ahora
                    </p>
                    <p className="text-md text-gray-600 mb-4">
                      Envíame {leadsCount} negocios de limpieza comercial cerca de mi
                      <br /> código postal{" "}
                    </p>

                    <div className="flex justify-center mb-6">
                      <div
                        className="
                          w-full
                          bg-[#BFEAF2]
                          border-[3px] border-[#26A94A]
                          rounded-xl
                          overflow-hidden
                          grid grid-cols-3
                        "
                      >
                        {plans.map((p, idx) => (
                          <button
                            key={p.qty}
                            type="button"
                            onClick={() => {
                              setLeadsCount(p.qty);
                              setSelectedPrice(p.price * 100);
                            }}
                            className={`
                              py-2
                              flex flex-col items-center justify-center
                              transition
                              cursor-pointer
                              ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                              ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                            `}
                          >
                            <span
                              className="
                                text-lg
                                font-extrabold leading-none
                                text-[#EAFB55]
                                drop-shadow-[1.5px_1.5px_0px_#2E7D32]
                              "
                            >
                              {p.qty}
                            </span>
                            <span className="text-sm font-extrabold leading-none text-[#1465B7]">
                              Leads
                            </span>
                            <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">
                              ${p.price}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div className="mt-8">
                        <button
                          className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer"
                          style={{ color: "#1465B7", fontSize: "28px" }}
                          onClick={() => {
                            setBuyNow('payment');
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Comprar ahora
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {loadingHeader && <div className="flex min-h-screen">
              <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
            </div>}
            {buyNow === "download" && <StripeFinalCodeCheck />}
            {buyNow === "payment" && (
              <button
                type="button"
                className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-[#1465B7] font-bold py-4 rounded-full border-3 border-[#26A94A] cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Completar el pago arriba ↑
              </button>
            )}

          </div>
        </div>
        <div className="container mx-auto max-w-5xl px-4 md:px-0">
          <div className="text-center mb-12">
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
              <img src={plus} width={250} height={158} />

              <div className="mt-4">
                <p className="text-3xl text-[#1465B7] font-bold">
                  Estos <span className="text-[#26A94A]">extras</span> con cada pedido
                </p>
              </div>

              <img src={plus} width={250} height={158} className="hidden sm:block" />
            </div>
            <div className="container mx-auto max-w-5xl px-4 md:px-0 mt-8">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 max-w-4xl justify-center mx-auto">
                <div>
                  <div className="relative flex justify-center items-center">
                    <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                      <img src={image99} width={130} height={71} />
                    </div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                      <img src={marketing} width={130} height={122} />
                    </div>
                  </div>

                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center mt-4 ml-4">
                    ¡Kit de marketing de limpieza comercial fácil!
                  </p>
                </div>

                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                    <img src={telemarekting} width={130} height={119} />
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                    Script de buzón de voz
                  </p>
                </div>
                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                    <img src={posty} width={130} height={98} />
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                    Plantillas de postales
                  </p>
                </div>
                <div>
                  <div className="relative flex justify-center items-center">
                    <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                      <img src={image49} width={130} height={77} />
                    </div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                      <img src={brochure} width={130} />
                    </div>
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center ml-6">
                    Plantillas de folleto
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guías relacionadas - las otras dos páginas (esta página = Conseguir Clientes) */}
      <div className="bg-[#e8f4f6] py-6 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-[#1465B7] font-semibold text-sm uppercase tracking-wide mb-3 text-center">
            Guías relacionadas
          </p>
          <p className="related-guides-links flex flex-wrap justify-center gap-x-4 gap-y-2 items-center text-center">
            <Link to={ES_HOME_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">Inicio</Link>
            <Link to={ES_PROMOTE_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">Cómo Promocionar tu Negocio de Limpieza Comercial</Link>
          </p>
        </div>
      </div>

      <div className="bg-[#bfeaf0]  py-16 mx-auto">
        <div className="text-base max-w-5xl mx-auto text-[#26A94A] text-center">
          <p>
            Para cualquier problema, contacta a soporte:{" "}
            <span className="underline">leadsnowproducts@gmail.com</span>
          </p>
          <div className="mt-2 text-base">
            <p>
              Leads Now Commercial Cleaning 12020 Shamrock Plaza #200 Omaha, NE
              68154
            </p>
          </div>
        </div>
      </div>

      <ChatWidget />
    </div>
  );
};

export default ConseguirClientesLimpieza;
